import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignContent: 'center',
    flexWrap: 'wrap',
  },
  innerContainer: {
    flex: 1,
  },
});
